module.exports = __webpack_public_path__ + "img/banner-intro.2a5ef6fa.svg";